
import { defineComponent, ref } from "vue";
import BaseModal from "@/components/modals/BaseModal.vue";
import { useStore } from "@/store";

export default defineComponent({
  props: {
    callback: {
      type: Function,
      default: undefined,
    },
  },
  components: {
    BaseModal,
  },
  setup(props) {
    const store = useStore();
    const intervals = [1, 3, 5, 10, 30, 60];
    const timer = ref(store.state.timer);
    const interval = ref(store.state.interval);
    const confirmHandler = () => {
      store.commit("setTimer", timer.value);
      store.commit("setInterval", interval.value);
      props.callback && props.callback();
    };
    const openHandler = () => {
      timer.value = store.state.timer;
      interval.value = store.state.interval;
    };
    const handleChangeTimer = (e: Event) => {
      timer.value = (e.target as HTMLInputElement).checked;
    };
    const handleChangeInterval = (e: Event) => {
      interval.value = Number((e.target as HTMLInputElement).value);
    };

    return {
      props,
      store,
      intervals,
      interval,
      timer,
      openHandler,
      confirmHandler,
      handleChangeTimer,
      handleChangeInterval,
    };
  },
});
